import type { QueryClient } from '@tanstack/react-query';

import { invoiceKeys } from './queries';
import type { InvoiceProject } from './types';

/** Linked projects that belong to another client than `to` — the ones a
 *  company change must drop. Each project's own company is read from what the
 *  form already knows: the saved links (`current`) and the picker list for the
 *  previous client (`from`) the user chose from. A project whose company isn't
 *  known is kept — the server has the final say (BE ADR-101). */
export function projectsOfAnotherClient(
  qc: QueryClient,
  { from, to, linked, current }: {
    from: string;
    to: string;
    linked: string[];
    current: InvoiceProject[];
  },
): string[] {
  const companyOf = new Map<string, number | null>();
  for (const p of current) companyOf.set(String(p.id), p.company);
  const listed = qc.getQueryData<InvoiceProject[]>(invoiceKeys.projectOptions(from));
  for (const p of listed ?? []) companyOf.set(String(p.id), p.company);
  const target = to ? Number(to) : null;
  return linked.filter((id) => {
    const company = companyOf.get(id);
    return company !== undefined && company !== null && company !== target;
  });
}
